{
  "roleplaySlotCap": 5,
  "roleplayGeneratorDailyCap": 5,
  "costOutlierMinCohort": 20,
  "costEventRetentionDays": 90,
  "speechRelayMaxConcurrentPerUser": 3,
  "speechRelayDailyAudioSecondsCap": 7200,
  "speechReconciliationDriftThreshold": 0.1,
  "speechReconciliationTtsCharsNoiseFloor": 10000,
  "speechReconciliationSttAudioSecondsNoiseFloor": 300,
  "llmReconciliationDriftThreshold": 0.1,
  "llmReconciliationTokensNoiseFloor": 20000
}
